/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The TemplatesContent model module.
 * @module model/TemplatesContent
 * @version 1.0.0
 */
export class TemplatesContent {
  /**
   * Constructs a new <code>TemplatesContent</code>.
   * @alias module:model/TemplatesContent
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplatesContent</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplatesContent} obj Optional instance to populate.
   * @return {module:model/TemplatesContent} The populated <code>TemplatesContent</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplatesContent();
      if (data.hasOwnProperty('from'))
        obj.from = ApiClient.convertToType(data['from'], 'String');
      if (data.hasOwnProperty('subject'))
        obj.subject = ApiClient.convertToType(data['subject'], 'String');
      if (data.hasOwnProperty('html'))
        obj.html = ApiClient.convertToType(data['html'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} from
 */
TemplatesContent.prototype.from = undefined;

/**
 * @member {String} subject
 */
TemplatesContent.prototype.subject = undefined;

/**
 * @member {String} html
 */
TemplatesContent.prototype.html = undefined;

